// extracted by mini-css-extract-plugin
export var alertIcon = "_v3-0";